import { Dispatch } from 'redux';
import ContactManagement from 'additiv-services/services/core/contactManagement';
import AdapterError from 'errors/AdapterError';
import ServerError from 'errors/ServerError';

// 1. Define Types/Interfaces
export interface MemberProfile {
    [key: string]: any;
}

export interface UserPayload {
    memberProfile: MemberProfile;
}

export const SET_USER = 'client-dashboard/auth/SET_USER';

export interface SetUserAction {
    type: typeof SET_USER;
    payload: UserPayload;
}

// 2. Action Creator
export function setUser(payload: UserPayload): SetUserAction {
    return { type: SET_USER, payload };
}

// 3. Thunk Action
export function getUser({ profileId }: { profileId: string }) {
    return (dispatch: Dispatch<SetUserAction>): Promise<UserPayload> => (
        new Promise<UserPayload>((resolve, reject) => {
            ContactManagement.getMembersProfile(profileId)
                .then((memberProfileResponse: { data: MemberProfile }) => {
                    try {
                        localStorage.setItem('memberId', profileId);
                        const data: UserPayload = {
                            memberProfile: memberProfileResponse.data,
                        };

                        dispatch(setUser(data));
                        resolve(data);
                    } catch (err: any) {
                        // Wrapping in AdapterError as per original logic
                        reject(new AdapterError(err));
                    }
                })
                .catch((err: any) => {
                    reject(err.type !== undefined ? err : new ServerError(err));
                });
        })
    );
}
